import { FC } from 'react';
import { Button, ButtonProps } from 'antd';
import { useErrorBoundary } from 'react-error-boundary';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './TryAgainButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('try-again-button');
addTranslations(translations);

export type TryAgainButtonProps = Omit<ButtonProps, 'id'>;

export const TryAgainButton: FC<TryAgainButtonProps> = (props) => {
  const { resetBoundary } = useErrorBoundary();
  const { onClick, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Button
      id="try-again"
      onClick={(event) => {
        resetBoundary();
        onClick?.(event);
      }}
      {...rest}
    >
      {t('button.try-again')}
    </Button>
  );
};
